import React, { useContext } from 'react';
import { Box, makeStyles } from '@material-ui/core';
import { ArrowForward } from '@material-ui/icons';
import { CustomizedButton, CustomizedTypography } from '@components/Customized';
import { BLOG_CARD_1, BLOG_CARD_2, BLOG_CARD_3 } from '../Assets';
import { HomeComponentContainer } from './styled';
import BlogCard, { BlogCardProps } from './Cards/BlogCard';
import { MediaQuery } from '@routes/Home/HomePresenter';
import useUserActionLog, {
  Enum_Action_Button_Enum
} from '@hooks/useUserActionLog';
import AppConfig from '@config';

const blogContent: BlogCardProps[] = [
  {
    img: BLOG_CARD_1,
    title: 'CNC 가공 총정리 - 공작기계를 통한 제품 생산',
    description: 'CNC 가공의 생산 원리와 세부 가공방식에 대한 가이드',
    onClick: () => {
      window.open(
        `${AppConfig.baseUrl}/blog/posts/CNC-가공-총정리-공작-기계를-통한-제품-생산`
      );
      return;
    }
  },
  {
    img: BLOG_CARD_2,
    title: '3D 프린팅 개념 총정리 - 시제품 제작의 모든 것',
    description: '3D 프린팅 가공방식별 장담점과 설계 요령',
    onClick: () => {
      window.open(
        `${AppConfig.baseUrl}/blog/posts/3D-프린팅-개념-총정리-시제품-제작의-모든것`
      );
      return;
    }
  },
  {
    img: BLOG_CARD_3,
    title: '사출 금형 총정리 - 양산을 위한 기구설계와 사출 성형',
    description: '금형 설계법과 재료별 특징에 대한 가이드',
    onClick: () => {
      window.open(
        `${AppConfig.baseUrl}/blog/posts/사출-금형-총정리-양산을-위한-기구-설계와-사출-성형`
      );
      return;
    }
  }
];

const Blog: React.FC = () => {
  const { container, cardBox } = useStyles();
  const { sm, md } = useContext(MediaQuery);
  const { insertButtonLog } = useUserActionLog();

  const onOpenBlog = () => {
    insertButtonLog('Button_Landing_MoreKnowledge');
    return window.open(`${AppConfig.baseUrl}/blog`);
  };

  return (
    <HomeComponentContainer
      padding={sm ? '100px 16px' : md ? '120px 0 ' : '140px 0'}
      className={container}
    >
      <Box className="title">
        <CustomizedTypography
          className="blogTitle"
          variant={'h1'}
          color="textPrimary"
          fontWeight="700"
        >
          자신에게 필요한 <br />
          제조 정보를 찾아보세요
        </CustomizedTypography>
        {!sm && (
          <CustomizedButton
            logId={Enum_Action_Button_Enum.Landing_MANUFACTURING_KNOWLEDGE_VIEW}
            variant="text"
            color="primary"
            size="large"
            endIcon={<ArrowForward />}
            onClick={onOpenBlog}
          >
            제조지식 더보기
          </CustomizedButton>
        )}
      </Box>
      <Box className={cardBox}>
        {blogContent.map((content, index) => (
          <BlogCard key={content.title} {...content} />
        ))}
      </Box>
      {sm && (
        <CustomizedButton
          logId={Enum_Action_Button_Enum.Landing_MANUFACTURING_KNOWLEDGE_VIEW}
          className="smButtom"
          variant="text"
          color="primary"
          size="large"
          endIcon={<ArrowForward />}
          onClick={onOpenBlog}
        >
          제조지식 더보기
        </CustomizedButton>
      )}
    </HomeComponentContainer>
  );
};

export default Blog;

const useStyles = makeStyles((theme) => ({
  container: {
    maxWidth: 960,
    margin: '0 auto',
    '& .title': {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      marginBottom: 32,
      '& button': {
        margin: 'auto 0 8px',
        fontSize: '20px',
        fontWeight: 500
      },
      [theme.breakpoints.down('sm')]: {
        '& .blogTitle': {
          fontSize: '28px'
        }
      }
    },
    '& .smButtom': {
      marginTop: 40
    }
  },
  cardBox: {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: 960
  }
}));
